import { blue, green, red } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de alteração de minuta.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_ALTERACAO_MINUTA = {
    ALTERADA                                : { id: 'ALTERADA',                                descricao: 'Minuta alterada',                                                cor: red[900]   },
    ALTERACAO_ANALISADA                     : { id: 'ALTERACAO_ANALISADA',                     descricao: 'Minuta com alteração(ões) analisada(s) pela Secretaria',         cor: green[700] },
    EMENTA_EOU_DECISAO_ALTERADAS            : { id: 'EMENTA_EOU_DECISAO_ALTERADAS',            descricao: 'Ementa/decisão alterada(s)',                                     cor: blue[900]  },
    ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS : { id: 'ALTERACAO_EMENTA_EOU_DECISAO_ANALISADAS', descricao: 'Ementa/decisão com alteração(ões) analisada(s) pela Secretaria', cor: green[300] }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de alteração de minuta.
 * @readonly
 */
export default class SituacaoAlteracaoMinuta {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_ALTERACAO_MINUTA);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_ALTERACAO_MINUTA = 'Não foi possível identificar a situação da minuta.';

    static getDescricao(id) {
        return SituacaoAlteracaoMinuta.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return SituacaoAlteracaoMinuta.situacaoBase.getValorPropriedade(id, 'cor');
    }
}
